'use client';

import { LegalPageShell } from 'Bomdisoft/shared/legal-page-shell';
import s from 'Bomdisoft/shared/legal-page-shell/styles.module.css';
import { cookieIntro, cookieManageBody, cookieManageHeading, cookieNotUseHeading, cookieNotUseItem1, cookieNotUseItem2, cookieNotUseItem3, cookieNotUseItem4, cookieSentryBody, cookieUseHeading, legalEyebrow, legalLastUpdated, legalTitleCookie, legalTitleCookieAccent } from 'Bomdisoft/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const EMAIL = 'support@bomdisoft.com';

const CookiePolicyPage = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  return (
    <LegalPageShell eyebrow={legalEyebrow[language]} lede={legalLastUpdated[language]} testId='cookie-policy-page' title={legalTitleCookie[language]} titleAccent={legalTitleCookieAccent[language]}>
      <section className={s.section}>
        <div className={s.content}>
          <p className={s.body}>{cookieIntro[language]}</p>
          <h2 className={s.sectionHeading}>{cookieUseHeading[language]}</h2>
          <ul className={s.list}>
            <li>
              <span className={s.strong}>Sentry</span> , {cookieSentryBody[language]}
            </li>
          </ul>
          <h2 className={s.sectionHeading}>{cookieNotUseHeading[language]}</h2>
          <ul className={s.list}>
            <li>{cookieNotUseItem1[language]}</li>
            <li>{cookieNotUseItem2[language]}</li>
            <li>{cookieNotUseItem3[language]}</li>
            <li>{cookieNotUseItem4[language]}</li>
          </ul>
          <h2 className={s.sectionHeading}>{cookieManageHeading[language]}</h2>
          <p className={s.body}>{cookieManageBody[language].replace('{email}', EMAIL)}</p>
        </div>
      </section>
    </LegalPageShell>
  );
};

export default CookiePolicyPage;
